 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_COVER from '@/components/00_cover'
 import LOVE_1 from '@/components/love_1'
 import A1_ARTICLE from '@/components/01_article'
 import A2_PRAISE from '@/components/02_praise'
 import A3_TITLE from '@/components/03_title'
 import A4_COPYRIGHT from '@/components/04_copyright'
 import A5_DEDICATION from '@/components/05_dedication'
 import A6_CONTENTS from '@/components/06_contents'
 import A7_INTRODUCTION from '@/components/07_introduction'
 import A8_MYTHANKS from '@/components/08_mythanks'
 import A9_CHAPTER01 from '@/components/09_chapter01'
 import A0_CHAPTER02 from '@/components/10_chapter02'
 import A1_CHAPTER03 from '@/components/11_chapter03'
 import A2_CHAPTER04 from '@/components/12_chapter04'
 import A3_CHAPTER05 from '@/components/13_chapter05'
 import LOVE_2 from '@/components/love_2'
 import A4_ABOUTTHEAUTHOR from '@/components/14_abouttheauthor'
 import A5_ABOUTTHEREADERS from '@/components/15_aboutthereaders'
 import A6_AUTHOR from '@/components/16_author'
 import A7_BACKCOVER from '@/components/17_backcover'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/06_contents",
 			"name" : "06_contents",
 			"component" : A6_CONTENTS
 		},
 		{
 			"path" : "/07_introduction",
 			"name" : "07_introduction",
 			"component" : A7_INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js